/**
 * @fileoverview This file is generated by the Angular 2 template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
/* tslint:disable */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
import * as import0 from '../../../../app/subapps/tour-of-heroes/team.component';
import * as import1 from '@angular/core/src/linker/view';
import * as import3 from '@angular/core/src/linker/view_utils';
import * as import4 from '@angular/core/src/metadata/view';
import * as import5 from '@angular/core/src/linker/view_type';
import * as import6 from '@angular/core/src/change_detection/constants';
import * as import7 from '@angular/core/src/linker/component_factory';
import * as import8 from '@angular/router/src/router';
import * as import9 from '../../../../app/subapps/tour-of-heroes/services/team.service';
import * as import10 from '../../../node_modules/@angular/router/src/directives/router_link.ngfactory';
import * as import11 from '@angular/core/src/linker/view_container';
import * as import12 from '../../../node_modules/@angular/common/src/directives/ng_for.ngfactory';
import * as import13 from '@angular/router/src/router_state';
import * as import14 from '@angular/core/src/linker/template_ref';
import * as import15 from '@angular/core/src/change_detection/differs/iterable_differs';
import * as import16 from '@angular/router/src/directives/router_link';
import * as import17 from '@angular/common/src/directives/ng_for';
import * as import18 from '@angular/core/src/change_detection/change_detection_util';
export var Wrapper_TeamComponent = (function () {
    function Wrapper_TeamComponent(p0, p1) {
        this._changed = false;
        this.context = new import0.TeamComponent(p0, p1);
    }
    Wrapper_TeamComponent.prototype.ngOnDetach = function (view, componentView, el) {
    };
    Wrapper_TeamComponent.prototype.ngOnDestroy = function () {
    };
    Wrapper_TeamComponent.prototype.ngDoCheck = function (view, el, throwOnChange) {
        var changed = this._changed;
        this._changed = false;
        if (!throwOnChange) {
            if ((view.numberOfChecks === 0)) {
                this.context.ngOnInit();
            }
        }
        return changed;
    };
    Wrapper_TeamComponent.prototype.checkHost = function (view, componentView, el, throwOnChange) {
    };
    Wrapper_TeamComponent.prototype.handleEvent = function (eventName, $event) {
        var result = true;
        return result;
    };
    Wrapper_TeamComponent.prototype.subscribe = function (view, _eventHandler) {
        this._eventHandler = _eventHandler;
    };
    return Wrapper_TeamComponent;
}());
var renderType_TeamComponent_Host = import3.createRenderComponentType('', 0, import4.ViewEncapsulation.None, [], {});
var View_TeamComponent_Host0 = (function (_super) {
    __extends(View_TeamComponent_Host0, _super);
    function View_TeamComponent_Host0(viewUtils, parentView, parentIndex, parentElement) {
        _super.call(this, View_TeamComponent_Host0, renderType_TeamComponent_Host, import5.ViewType.HOST, viewUtils, parentView, parentIndex, parentElement, import6.ChangeDetectorStatus.CheckAlways);
    }
    View_TeamComponent_Host0.prototype.createInternal = function (rootSelector) {
        this._el_0 = import3.selectOrCreateRenderHostElement(this.renderer, 'my-team', import3.EMPTY_INLINE_ARRAY, rootSelector, null);
        this.compView_0 = new View_TeamComponent0(this.viewUtils, this, 0, this._el_0);
        this._TeamComponent_0_3 = new Wrapper_TeamComponent(this.injectorGet(import8.Router, this.parentIndex), this.injectorGet(import9.TeamService, this.parentIndex));
        this.compView_0.create(this._TeamComponent_0_3.context);
        this.init(this._el_0, (this.renderer.directRenderer ? null : [this._el_0]), null);
        return new import7.ComponentRef_(0, this, this._el_0, this._TeamComponent_0_3.context);
    };
    View_TeamComponent_Host0.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import0.TeamComponent) && (0 === requestNodeIndex))) {
            return this._TeamComponent_0_3.context;
        }
        return notFoundResult;
    };
    View_TeamComponent_Host0.prototype.detectChangesInternal = function (throwOnChange) {
        this._TeamComponent_0_3.ngDoCheck(this, this._el_0, throwOnChange);
        this.compView_0.detectChanges(throwOnChange);
    };
    View_TeamComponent_Host0.prototype.destroyInternal = function () {
        this.compView_0.destroy();
    };
    View_TeamComponent_Host0.prototype.visitRootNodesInternal = function (cb, ctx) {
        cb(this._el_0, ctx);
    };
    return View_TeamComponent_Host0;
}(import1.AppView));
export var TeamComponentNgFactory = new import7.ComponentFactory('my-team', View_TeamComponent_Host0, import0.TeamComponent);
var styles_TeamComponent = [];
var renderType_TeamComponent = import3.createRenderComponentType('', 0, import4.ViewEncapsulation.None, styles_TeamComponent, {});
export var View_TeamComponent0 = (function (_super) {
    __extends(View_TeamComponent0, _super);
    function View_TeamComponent0(viewUtils, parentView, parentIndex, parentElement) {
        _super.call(this, View_TeamComponent0, renderType_TeamComponent, import5.ViewType.COMPONENT, viewUtils, parentView, parentIndex, parentElement, import6.ChangeDetectorStatus.CheckAlways);
        this._arr_38 = import3.pureProxy1(function (p0) {
            return [p0];
        });
    }
    View_TeamComponent0.prototype.createInternal = function (rootSelector) {
        var parentRenderNode = this.renderer.createViewRoot(this.parentElement);
        this._el_0 = import3.createRenderElement(this.renderer, parentRenderNode, 'button', new import3.InlineArray2(2, 'class', 'btn btn-primary pull-right'), null);
        this._RouterLink_0_3 = new import10.Wrapper_RouterLink(this.parentView.injectorGet(import8.Router, this.parentIndex), this.parentView.injectorGet(import13.ActivatedRoute, this.parentIndex));
        this._text_1 = this.renderer.createText(this._el_0, '\n    ', null);
        this._el_2 = import3.createRenderElement(this.renderer, this._el_0, 'span', new import3.InlineArray4(4, 'aria-hidden', 'true', 'class', 'glyphicon glyphicon-plus'), null);
        this._text_3 = this.renderer.createText(this._el_0, ' New player\n', null);
        this._text_4 = this.renderer.createText(parentRenderNode, '\n', null);
        this._el_5 = import3.createRenderElement(this.renderer, parentRenderNode, 'table', new import3.InlineArray2(2, 'class', 'table table-striped'), null);
        this._text_6 = this.renderer.createText(this._el_5, '\n    ', null);
        this._el_7 = import3.createRenderElement(this.renderer, this._el_5, 'thead', import3.EMPTY_INLINE_ARRAY, null);
        this._text_8 = this.renderer.createText(this._el_7, '\n    ', null);
        this._el_9 = import3.createRenderElement(this.renderer, this._el_7, 'tr', import3.EMPTY_INLINE_ARRAY, null);
        this._text_10 = this.renderer.createText(this._el_9, '\n        ', null);
        this._el_11 = import3.createRenderElement(this.renderer, this._el_9, 'th', new import3.InlineArray2(2, 'style', 'width: 50px;'), null);
        this._text_12 = this.renderer.createText(this._el_11, '#', null);
        this._text_13 = this.renderer.createText(this._el_9, '\n        ', null);
        this._el_14 = import3.createRenderElement(this.renderer, this._el_9, 'th', import3.EMPTY_INLINE_ARRAY, null);
        this._text_15 = this.renderer.createText(this._el_14, 'First name', null);
        this._text_16 = this.renderer.createText(this._el_9, '\n        ', null);
        this._el_17 = import3.createRenderElement(this.renderer, this._el_9, 'th', import3.EMPTY_INLINE_ARRAY, null);
        this._text_18 = this.renderer.createText(this._el_17, 'Last name', null);
        this._text_19 = this.renderer.createText(this._el_9, '\n        ', null);
        this._text_20 = this.renderer.createText(this._el_9, '\n        ', null);
        this._el_21 = import3.createRenderElement(this.renderer, this._el_9, 'th', import3.EMPTY_INLINE_ARRAY, null);
        this._text_22 = this.renderer.createText(this._el_21, 'Gender', null);
        this._text_23 = this.renderer.createText(this._el_9, '\n        ', null);
        this._el_24 = import3.createRenderElement(this.renderer, this._el_9, 'th', import3.EMPTY_INLINE_ARRAY, null);
        this._text_25 = this.renderer.createText(this._el_24, 'Email', null);
        this._text_26 = this.renderer.createText(this._el_9, '\n    ', null);
        this._text_27 = this.renderer.createText(this._el_7, '\n    ', null);
        this._text_28 = this.renderer.createText(this._el_5, '\n    ', null);
        this._el_29 = import3.createRenderElement(this.renderer, this._el_5, 'tbody', import3.EMPTY_INLINE_ARRAY, null);
        this._text_30 = this.renderer.createText(this._el_29, '\n    ', null);
        this._anchor_31 = this.renderer.createTemplateAnchor(this._el_29, null);
        this._vc_31 = new import11.ViewContainer(31, 29, this, this._anchor_31);
        this._TemplateRef_31_5 = new import14.TemplateRef_(this, 31, this._anchor_31);
        this._NgFor_31_6 = new import12.Wrapper_NgFor(this._vc_31.vcRef, this._TemplateRef_31_5, this.parentView.injectorGet(import15.IterableDiffers, this.parentIndex), this.ref);
        this._text_32 = this.renderer.createText(this._el_29, '\n    ', null);
        this._text_33 = this.renderer.createText(this._el_5, '\n', null);
        var disposable_0 = import3.subscribeToRenderElement(this, this._el_0, new import3.InlineArray2(2, 'click', null), this.eventHandler(this.handleEvent_0));
        this.init(null, (this.renderer.directRenderer ? null : [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._text_4,
            this._el_5,
            this._text_6,
            this._el_7,
            this._text_8,
            this._el_9,
            this._text_10,
            this._el_11,
            this._text_12,
            this._text_13,
            this._el_14,
            this._text_15,
            this._text_16,
            this._el_17,
            this._text_18,
            this._text_19,
            this._text_20,
            this._el_21,
            this._text_22,
            this._text_23,
            this._el_24,
            this._text_25,
            this._text_26,
            this._text_27,
            this._text_28,
            this._el_29,
            this._text_30,
            this._anchor_31,
            this._text_32,
            this._text_33
        ]), [disposable_0]);
        return null;
    };
    View_TeamComponent0.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import16.RouterLink) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 3)))) {
            return this._RouterLink_0_3.context;
        }
        if (((token === import14.TemplateRef) && (31 === requestNodeIndex))) {
            return this._TemplateRef_31_5;
        }
        if (((token === import17.NgFor) && (31 === requestNodeIndex))) {
            return this._NgFor_31_6.context;
        }
        return notFoundResult;
    };
    View_TeamComponent0.prototype.detectChangesInternal = function (throwOnChange) {
        var currVal_0_0_0 = this._arr_38('/team/player/new');
        this._RouterLink_0_3.check_routerLink(currVal_0_0_0, throwOnChange, false);
        this._RouterLink_0_3.ngDoCheck(this, this._el_0, throwOnChange);
        var currVal_31_0_0 = this.context.team;
        this._NgFor_31_6.check_ngForOf(currVal_31_0_0, throwOnChange, false);
        this._NgFor_31_6.ngDoCheck(this, this._anchor_31, throwOnChange);
        this._vc_31.detectChangesInNestedViews(throwOnChange);
    };
    View_TeamComponent0.prototype.destroyInternal = function () {
        this._vc_31.destroyNestedViews();
    };
    View_TeamComponent0.prototype.createEmbeddedViewInternal = function (nodeIndex) {
        if ((nodeIndex == 31)) {
            return new View_TeamComponent1(this.viewUtils, this, 31, this._anchor_31, this._vc_31);
        }
        return null;
    };
    View_TeamComponent0.prototype.handleEvent_0 = function (eventName, $event) {
        this.markPathToRootAsCheckOnce();
        var result = true;
        result = (this._RouterLink_0_3.handleEvent(eventName, $event) && result);
        return result;
    };
    return View_TeamComponent0;
}(import1.AppView));
var View_TeamComponent1 = (function (_super) {
    __extends(View_TeamComponent1, _super);
    function View_TeamComponent1(viewUtils, parentView, parentIndex, parentElement, declaredViewContainer) {
        _super.call(this, View_TeamComponent1, renderType_TeamComponent, import5.ViewType.EMBEDDED, viewUtils, parentView, parentIndex, parentElement, import6.ChangeDetectorStatus.CheckAlways, declaredViewContainer);
        this._arr_19 = import3.pureProxy2(function (p0, p1) {
            return [
                p0,
                p1
            ];
        });
        this._expr_20 = import18.UNINITIALIZED;
        this._expr_21 = import18.UNINITIALIZED;
        this._expr_22 = import18.UNINITIALIZED;
        this._expr_23 = import18.UNINITIALIZED;
        this._expr_24 = import18.UNINITIALIZED;
    }
    View_TeamComponent1.prototype.createInternal = function (rootSelector) {
        this._el_0 = import3.createRenderElement(this.renderer, null, 'tr', new import3.InlineArray2(2, 'style', 'cursor: pointer;'), null);
        this._RouterLink_0_3 = new import10.Wrapper_RouterLink(this.parentView.parentView.injectorGet(import8.Router, this.parentView.parentIndex), this.parentView.parentView.injectorGet(import13.ActivatedRoute, this.parentView.parentIndex));
        this._text_1 = this.renderer.createText(this._el_0, '\n        ', null);
        this._el_2 = import3.createRenderElement(this.renderer, this._el_0, 'td', import3.EMPTY_INLINE_ARRAY, null);
        this._text_3 = this.renderer.createText(this._el_2, '', null);
        this._text_4 = this.renderer.createText(this._el_0, '\n        ', null);
        this._el_5 = import3.createRenderElement(this.renderer, this._el_0, 'td', import3.EMPTY_INLINE_ARRAY, null);
        this._text_6 = this.renderer.createText(this._el_5, '', null);
        this._text_7 = this.renderer.createText(this._el_0, '\n        ', null);
        this._el_8 = import3.createRenderElement(this.renderer, this._el_0, 'td', import3.EMPTY_INLINE_ARRAY, null);
        this._text_9 = this.renderer.createText(this._el_8, '', null);
        this._text_10 = this.renderer.createText(this._el_0, '\n        ', null);
        this._text_11 = this.renderer.createText(this._el_0, '\n        ', null);
        this._el_12 = import3.createRenderElement(this.renderer, this._el_0, 'td', import3.EMPTY_INLINE_ARRAY, null);
        this._text_13 = this.renderer.createText(this._el_12, '', null);
        this._text_14 = this.renderer.createText(this._el_0, '\n        ', null);
        this._el_15 = import3.createRenderElement(this.renderer, this._el_0, 'td', import3.EMPTY_INLINE_ARRAY, null);
        this._text_16 = this.renderer.createText(this._el_15, '', null);
        this._text_17 = this.renderer.createText(this._el_0, '\n    ', null);
        var disposable_0 = import3.subscribeToRenderElement(this, this._el_0, new import3.InlineArray2(2, 'click', null), this.eventHandler(this.handleEvent_0));
        this.init(this._el_0, (this.renderer.directRenderer ? null : [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._text_4,
            this._el_5,
            this._text_6,
            this._text_7,
            this._el_8,
            this._text_9,
            this._text_10,
            this._text_11,
            this._el_12,
            this._text_13,
            this._text_14,
            this._el_15,
            this._text_16,
            this._text_17
        ]), [disposable_0]);
        return null;
    };
    View_TeamComponent1.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import16.RouterLink) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 17)))) {
            return this._RouterLink_0_3.context;
        }
        return notFoundResult;
    };
    View_TeamComponent1.prototype.detectChangesInternal = function (throwOnChange) {
        var currVal_0_0_0 = this._arr_19('/team/player/edit', this.context.$implicit._id);
        this._RouterLink_0_3.check_routerLink(currVal_0_0_0, throwOnChange, false);
        this._RouterLink_0_3.ngDoCheck(this, this._el_0, throwOnChange);
        var currVal_20 = import3.inlineInterpolate(1, '', (this.context.index + 1), '');
        if (import3.checkBinding(throwOnChange, this._expr_20, currVal_20)) {
            this.renderer.setText(this._text_3, currVal_20);
            this._expr_20 = currVal_20;
        }
        var currVal_21 = import3.inlineInterpolate(1, '', this.context.$implicit.name, '');
        if (import3.checkBinding(throwOnChange, this._expr_21, currVal_21)) {
            this.renderer.setText(this._text_6, currVal_21);
            this._expr_21 = currVal_21;
        }
        var currVal_22 = import3.inlineInterpolate(1, '', this.context.$implicit.lastName, '');
        if (import3.checkBinding(throwOnChange, this._expr_22, currVal_22)) {
            this.renderer.setText(this._text_9, currVal_22);
            this._expr_22 = currVal_22;
        }
        var currVal_23 = import3.inlineInterpolate(1, '', this.context.$implicit.gender, '');
        if (import3.checkBinding(throwOnChange, this._expr_23, currVal_23)) {
            this.renderer.setText(this._text_13, currVal_23);
            this._expr_23 = currVal_23;
        }
        var currVal_24 = import3.inlineInterpolate(1, '', this.context.$implicit.email, '');
        if (import3.checkBinding(throwOnChange, this._expr_24, currVal_24)) {
            this.renderer.setText(this._text_16, currVal_24);
            this._expr_24 = currVal_24;
        }
    };
    View_TeamComponent1.prototype.visitRootNodesInternal = function (cb, ctx) {
        cb(this._el_0, ctx);
    };
    View_TeamComponent1.prototype.handleEvent_0 = function (eventName, $event) {
        this.markPathToRootAsCheckOnce();
        var result = true;
        result = (this._RouterLink_0_3.handleEvent(eventName, $event) && result);
        return result;
    };
    return View_TeamComponent1;
}(import1.AppView));
//# sourceMappingURL=team.component.ngfactory.js.map